import React, { Component } from 'react';
import { I18n } from 'react-i18next';
import Menu from './menu';
import Footer from './footer';

class Service extends Component {
    componentDidMount () {
        setTimeout(() => this.node.scrollIntoView(), 0);
    }

    render() {
        return (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <div id="wraper-other" ref={node => this.node = node}>
                            <header>
                                <Menu currentItem="service"/>
                            </header>
                            <div id="service">
                                <div className="container">
                                    <div className="row text-center">
                                        <div className="col-xs-12 col-sm-12 col-md-12 service-top">
                                            <h2 className="wow bounce">ETDS</h2>
                                            <h4>Easy token distribution system</h4>
                                            <div className="st-info">
                                                <p>{t('service_1')}</p>
                                                <p>{t('service_2')}</p>
                                                <p>{t('service_3')}</p>
                                                <p>{t('service_4')}</p>
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12 service-bottom">
                                            <h2 className="wow flash">{t('service_5')}</h2>
                                            <div className="col-xs-6 col-sm-6 col-md-6 sb-left wow slideInLeft">
                                                <img src="/images/3a.png" alt=""/>
                                                <p className="txt-dis-title">{t('service_8')}</p>
                                            </div>
                                            <div className="col-xs-6 col-sm-6 col-md-6 sb-right wow slideInRight">
                                                <div className="sbr-top">
                                                    <img src="/images/3b.png" alt=""/>
                                                    <span className="txt-dis-describe"> {t('service_6')} </span>
                                                </div>
                                                <div className="sbr-bottom">
                                                    <img src="/images/3c.png" alt=""/>
                                                    <span className="txt-dis-describe">{t('service_7')}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-center btn-service wow shake" data-wow-delay="1s">
                                            <a className="btn btn-distribution">{t('service_8')}</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer/>
                        </div>
                    )
                }
            </I18n>
        );
    }
}

export default Service;



// WEBPACK FOOTER //
// ./src/containers/service.jsx